import { render, staticRenderFns } from "./employee-bulk-update.vue?vue&type=template&id=61406b44"
import script from "./employee-bulk-update.vue?vue&type=script&lang=js"
export * from "./employee-bulk-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports